// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import gql from 'graphql-tag';

export const CROPS_BLENDS_QUERY = gql`
  query OrderFormCrops {
    crops(
      filters: [{ name: "crop.status", operator: "!=", value: "archived" }]
      orderBy: [{ name: "crop.crop_name", direction: "asc" }]
    ) {
      edges {
        node {
          id
          crop_name
          status
          total_grow_time
          harvest_buffer_time
          yield_per_tray
          yield_unit
          buffer_percentage
          edge_sizes {
            edges {
              node {
                id
                size
                unit
                price_per_item
              }
            }
          }
        }
      }
    }
    blends(
      filters: [{ name: "blend.status", operator: "!=", value: "archived" }]
      orderBy: [{ name: "blend.blend_name", direction: "asc" }]
    ) {
      edges {
        node {
          id
          blend_name
          status
          edge_sizes {
            edges {
              node {
                id
                size
                unit
                price_per_item
              }
            }
          }
          crops {
            edges {
              node {
                id
                percent_of_blend
                crop {
                  id
                  crop_name
                  total_grow_time
                  harvest_buffer_time
                  yield_per_tray
                  yield_unit
                  buffer_percentage
                }
              }
            }
          }
        }
      }
    }
  }
`;
